import React from "react";
import * as styles from "components/WebQuoteModal/WebQuoteModal.module.scss";
import { Trans } from "@lingui/react/macro";
import { Icon } from "@silversea-ssc/ui-components-react";
import { ModalFooterCta } from "components/WebQuoteModal/ModalFooterCta/ModalFooterCta";

type ThankYouModalStepProps = {
  onRequestClose: () => void;
  fycRedirectUrl?: string;
};

export const ThankYouModalStep: React.FC<ThankYouModalStepProps> = ({
  onRequestClose,
  fycRedirectUrl
}) => {
  return (
    <>
      <div className={styles.subscriptionConfirmedMessage}>
        <Icon padding="inline" name="circle-check" size="2x" />
        <Trans>Request confirmed</Trans>
      </div>
      <div className={styles.feedbackMessageContainer}>
        <div className={styles.feedbackTitle}>
          <Trans>Thank you!</Trans>
          <br />
          <Trans>Your quote is on its way</Trans>
        </div>
        <Trans>
          Please note that this quote will be valid for a limited time only. A
          member of our Reservation Team will be in touch soon to finalize the
          details of your exclusive Silversea travel experience.
        </Trans>
      </div>
      <ModalFooterCta
        fycRedirectUrl={fycRedirectUrl}
        onRequestClose={onRequestClose}
      />
    </>
  );
};
